import { ArrowUpRight } from "lucide-react";
import { CAT_ICONS } from "../../lib/icons";
import { KAT_DOT } from "../KondisiBadge";

const KATS = ["BAIK", "RUSAK RINGAN", "RUSAK BERAT", "LAINNYA"];

const Bar = ({ c }) => (
  <div className="flex h-2 w-full min-w-[120px] bg-muted overflow-hidden">
    {c.has_kondisi && c.total > 0 &&
      KATS.map((k) => <div key={k} className={KAT_DOT[k]} style={{ width: `${(c.kondisi[k] / c.total) * 100}%` }} />)}
  </div>
);

export const CategoryRecap = ({ categories, onOpen }) => (
  <section className="border bg-card" data-testid="category-recap">
    <div className="px-5 py-4 border-b flex items-center justify-between">
      <h2 className="font-heading font-bold text-base md:text-lg">Rekap per Kategori</h2>
      <div className="hidden md:flex gap-4 text-[11px] text-muted-foreground">
        {KATS.map((k) => (
          <span key={k} className="flex items-center gap-1.5"><i className={`h-2 w-2 ${KAT_DOT[k]}`} />{k}</span>
        ))}
      </div>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left border-b bg-muted/50">
            <th className="px-3 sm:px-5 py-2.5 eyebrow">Kategori</th>
            <th className="px-2 sm:px-3 py-2.5 eyebrow text-right">Total</th>
            <th className="px-2 sm:px-3 py-2.5 eyebrow text-right">Baik</th>
            <th className="px-2 sm:px-3 py-2.5 eyebrow text-right"><span className="sm:hidden">RR</span><span className="hidden sm:inline">R. Ringan</span></th>
            <th className="px-2 sm:px-3 py-2.5 eyebrow text-right"><span className="sm:hidden">RB</span><span className="hidden sm:inline">R. Berat</span></th>
            <th className="hidden md:table-cell px-5 py-2.5 eyebrow">Komposisi</th>
            <th className="hidden md:table-cell" />
          </tr>
        </thead>
        <tbody>
          {categories.map((c) => {
            const Icon = CAT_ICONS[c.key];
            return (
              <tr key={c.key} onClick={() => onOpen(c.key)} data-testid={`recap-row-${c.key}`}
                className="border-b last:border-0 cursor-pointer hover:bg-muted/50 transition-colors group">
                <td className="px-3 sm:px-5 py-3"><span className="flex items-center gap-2.5 font-medium"><Icon className="h-4 w-4 shrink-0 text-muted-foreground" />{c.label}</span></td>
                <td className="px-2 sm:px-3 py-3 text-right font-mono font-medium">{c.total}</td>
                <td className="px-2 sm:px-3 py-3 text-right font-mono">{c.has_kondisi ? c.kondisi.BAIK : "-"}</td>
                <td className="px-2 sm:px-3 py-3 text-right font-mono">{c.has_kondisi ? c.kondisi["RUSAK RINGAN"] : "-"}</td>
                <td className="px-2 sm:px-3 py-3 text-right font-mono">{c.has_kondisi ? c.kondisi["RUSAK BERAT"] : "-"}</td>
                <td className="hidden md:table-cell px-5 py-3"><Bar c={c} /></td>
                <td className="hidden md:table-cell pr-4"><ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </section>
);
